import { Box } from "@mui/material";
import ProjectDashboard from "features/project/components/ProjectDashboard";

function ProjectHomePage() {
  return (
    <Box
      sx={{
        height: "calc(100dvh - 100px)",
        width: "100%",
        transform: "translateY(-40px)",
        overflow: "hidden",
      }}
    >
      <ProjectDashboard />
    </Box>
  );
}

export default ProjectHomePage;
